const COLS = [
  {
    title: "看瓜栏目",
    links: ["今日热瓜榜", "猛料现场", "独家深扒", "圈内速递", "主角档案"],
    anchors: ["#hot", "#feed", "#deep", "#brief", "#people"],
  },
  {
    title: "围观入口",
    links: ["下载 App", "匿名投稿", "订阅某位人物", "关键词提醒", "免责声明"],
    anchors: ["#report", "#report", "#report", "#report", "#report"],
  },
  {
    title: "关于本站",
    links: ["栏目说明", "信息来源标注规则", "编缉团队", "联系方式", "合作与广告"],
    anchors: ["#report", "#report", "#report", "#report", "#report"],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand block */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-sparkling-2-fill text-lg" />
              </span>
              <span className="font-heading text-2xl font-black tracking-wide">
                海角<span className="text-accent-400">天崖</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-[14px] leading-6 text-background-50/70">
              专注收集与交叉核验圈内黑料、猛料与内幕的匿名爆料聚合站。想看海角天崖的瓜，就蹲这一页——有没有人扒出新东西，天天有更新。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["黑料", "猛料", "内幕", "曝光", "圈内瓜"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-[12px] text-background-50/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {/* link columns */}
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 md:col-span-7">
            {COLS.map((c) => (
              <div key={c.title}>
                <h4 className="font-heading text-[15px] font-bold text-accent-300">{c.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {c.links.map((l, i) => (
                    <li key={l}>
                      <a
                        href={c.anchors[i]}
                        className="inline-flex items-center gap-1.5 text-[13px] text-background-50/75 transition-colors hover:text-background-50"
                      >
                        <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-50/30" />
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-[12px] leading-6 text-background-50/55 sm:flex-row sm:items-center sm:justify-between">
          <p>本站内容均为匿名投稿整理与示意演示，所有人物均为虚构代称，请理性吃瓜、勿对号入座。</p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            © 2026 海角天崖 · 匿名爆料聚合站
          </p>
        </div>
      </div>
    </footer>
  );
}